import { Dashboard, RequestsByMe } from '@/components';

export const RequestsByMePage = () => (
  <Dashboard isSearch openLogIn>
    <RequestsByMe />
  </Dashboard>
);
